import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotifactionService {
  constructor(private messageService: MessageService) {}

  success(title:string, message: string, summary:string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: message });
  }

  error(title:string, message: string, summary:string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: message });
  }

  warn(title:string, message: string, summary:string) {
    this.messageService.add({ severity: 'warn', summary: summary, detail: message });
  }

  info(title:string, message: string, summary:string) {
    this.messageService.add({ severity: 'info', summary: summary, detail: message });
  }
}

